// ** IMPORTANT **: Keep in sync with functions/src/index.ts
export enum AUDIO_TRANSCRIPTION_JOB_STATUS {
    queued = 'queued',
    processing = 'processing',
    completed = 'completed',
    offloaded = 'offloaded',
    skipped = 'skipped',
    failed = 'failed',
}
